var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandoverOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "handover-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.259,
    height: 74,
    viewBox: "0 0 111.259 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 111.259,
    height: 74,
    rx: 8,
    fill: "#ff6200",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M16.537,38.272a1.5,1.5,0,0,1-.057-2.12L50.3.468a1.5,1.5,0,1,1,2.178,2.064L18.657,38.216a1.5,1.5,0,0,1-2.12.057Zm26.7-3.929A1.723,1.723,0,0,1,41.531,32.6,10.342,10.342,0,0,1,51.769,22.156H57.02A10.342,10.342,0,0,1,67.259,32.6h0a1.723,1.723,0,0,1-1.7,1.741Zm-39.56,0A3.716,3.716,0,0,1,0,30.592V8.092a3.718,3.718,0,0,1,3.677-3.75h9.188v7.5A1.854,1.854,0,0,0,14.7,13.717h7.352v15.1l-5.234,5.521Zm32.762-24.6V5.636l3.948,3.842-6.118,6.455a11.7,11.7,0,0,0-8.907,5.116C26.394,15.906,29.256,10.782,36.438,9.743ZM50.866,18.43a7.279,7.279,0,0,1-2.836-2.838,7.623,7.623,0,0,1-.506-6.377L51.613,4.9a7.274,7.274,0,0,1,9.149,3.192,7.636,7.636,0,0,1,0,7.5,7.277,7.277,0,0,1-9.9,2.838ZM14.7,11.842v-7.5l7.351,7.5Z",
    transform: "translate(22.242 7.25)",
    fill: "#161616",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "off",
    d: "M7.824.288c4.512,0,6.6-2.088,6.6-6.648v-3.6c0-4.56-2.088-6.648-6.6-6.648s-6.6,2.088-6.6,6.648v3.6C1.224-1.8,3.312.288,7.824.288Zm0-3.1c-2.16,0-3-1.032-3-3.6v-3.5c0-2.568.84-3.6,3-3.6s3,1.032,3,3.6v3.5C10.824-3.84,9.984-2.808,7.824-2.808ZM28.44-13.224v-3.1H17.448V0h3.6V-6.6H27.24V-9.7H21.048v-3.528Zm13.3,0v-3.1H30.744V0h3.6V-6.6h6.192V-9.7H34.344v-3.528Z",
    transform: "translate(34.242 67.183)",
    fill: "#050020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandoverOff);
export default __webpack_public_path__ + "static/media/handover-off.b774df0200f2c8b2183b8b1c2ba95a8d.svg";
export { ForwardRef as ReactComponent };